<template>
  <div>
    <div @click="toggleCollapse" class="tag-listing-filters-group-name">
      {{ group.tagGroupName }}
      <button class="tag-listing-filters-group-collapse-btn">
        <em :class="['ti-close', { 'ti-angle-down': !collapsed, 'ti-angle-up': collapsed }]"></em>
      </button>
    </div>
    <transition name="collapse-fade">
      <div
        v-if="!collapsed"
        class="tag-listing-filters-tag-entries"
        :class="getTagEntriesClassName"
      >
        <EntryFilter
          v-for="tagEntry in entries"
          :key="tagEntry.id"
          :entry="tagEntry"
          :group="group"
          class="tag-listing-filters-tag-entry"
        >
        </EntryFilter>
      </div>
    </transition>
  </div>
</template>

<script>

import EntryFilter from './EntryFilter'

export default {
  name: 'GroupFilter',
  components: {
    EntryFilter
  },
  data () {
    return {
      collapsed: false
    }
  },
  props: {
    group: {
      tagDisplayType: '',
      tagGroupId: '',
      tagGroupName: null,
      tagGroupStep: 0,
      tagGroupDisplayPosition: 0,
      tags: []
    },
    entries: {
      type: Array
    },
    isBaseGroup: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getTagEntriesClassName () {
      let className = ''
      className += this.group.tagDisplayType
      if (this.collapsed) {
        className += ' collapsed'
      }
      return className
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-listing-filters-group-collapse-btn {
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  text-align: center;
  background: unset;
  border: unset;
}
.ti-close {
  font-size: 14px;
}
.collapse-fade-enter-active, .collapse-fade-leave-active {
  transition: opacity 0.5s;
}
.collapse-fade-enter, .collapse-fade-leave-to {
  opacity: 0;
}
</style>
